import {LoadSpacingConfiguration} from '../../../../fields/loadSpacing/types'
import {getDefaultTruckSize, isMultipleTruck} from '../../../../fields/trucks/trucks.utils'
import {TruckConfiguration} from '../../../../fields/trucks/types'
import {OrderDto} from '../../../types'
import {ChangeableFieldsOptionsDto} from '../../options/types'

export const buildLoadSpacingConfiguration = (
  order: OrderDto,
  configuration: LoadSpacingConfiguration & TruckConfiguration,
  changeableFields: ChangeableFieldsOptionsDto,
  respectStartedOrderSpacingRestrictions: boolean
): LoadSpacingConfiguration => {
  const {loadSpacing} = configuration
  if (!respectStartedOrderSpacingRestrictions || !loadSpacing.isEnabled) {
    return {loadSpacing}
  }

  const originalIsMultipleTruck = isMultipleTruck(
    order.lineItems[0].quantity,
    getDefaultTruckSize(configuration.trucks)
  )
  const disabledFields = (['loadSpace', 'flowRate'] as const).filter(
    (field) => changeableFields[field]?.isEnabled === false
  )
  const {multipleTrucks} = loadSpacing.scenarios

  return {
    loadSpacing: {
      ...loadSpacing,
      orderChange: {originalIsMultipleTruck, disabledFields},
      scenarios: {
        ...loadSpacing.scenarios,
        multipleTrucks: {
          ...multipleTrucks,
          loadSpace: multipleTrucks.loadSpace && !disabledFields.includes('loadSpace'),
          flowRate: multipleTrucks.flowRate && !disabledFields.includes('flowRate')
        }
      }
    }
  }
}
